import React from 'react';

const PlaceholderRDPComponent = () => (
  <div className='restraunt-detail-wrapper row'>
    <div className='restraunt-detail-addr col-md-5 placeholder'>
      <div className='table retaurant-view-container container'>
        <div className='loading card-title shorter-s' />
        <div className='loading card-title shorter-m' />
        <div className='loading table-content' />
        <div className='loading table-content' />
        <div className='loading table-content' />
      </div>
    </div>
    <div className='restraunt-detail-cnt col-md-7 placeholder'>
      <div className='table retaurant-view-container container'>
        <div className='loading card-title shorter-s' />
        <div className='loading card-title shorter-m' />
        <div className='loading table-content' />
        <div className='loading table-content' />
        <div className='loading table-content' />
      </div>
    </div>
  </div>
);

export default React.memo(PlaceholderRDPComponent);
